import { useStaticQuery, graphql } from 'gatsby';

const useLists = () => {
  const data = useStaticQuery(graphql`
    query useListsQuery {
      allSanityList {
        nodes {
          title
          items {
            _rawDescription
            externalLink
            internalLink {
              slug {
                current
              }
            }
            media {
              alt
              imageType
              asset {
                gatsbyImageData(placeholder: BLURRED, formats: WEBP)
                url
              }
            }
            date
            number
            position
            tags {
              title
            }
            title
          }
        }
      }
    }
  `);

  const lists = data.allSanityList.nodes;

  return lists;
};

export { useLists };
